export default __webpack_public_path__ + "static/media/icon-coloring-pages.9805cd7b.png";